import styled from "styled-components";

const UserManagerWrap = styled.section`
  /* display: grid; */
  grid-template-rows: min-content 1fr;

  .admin-actions {
    display: grid;
    align-items: center;
    border-bottom: 1px solid var(--light-border);
    height: 32px;
    padding: 5px 10px;
    display: flex;
    justify-content: space-between;

    .admin-btns {
      display: flex;
    }

    .group-stats {
      p {
        margin: 0px;
        font-weight: 600;
      }
    }
  }

  .user-admin {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--light-border);
    height: 32px;
    padding: 5px 10px;
    justify-content: end;
  }

  /* .user-group-table {
    tbody tr {
      height: 32px;
    }
  } */

  .user-group-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    thead th {
      text-align: left;
      padding: 4px 8px;
      height: 32px;
      background-color: #f5f5f5;
      border-bottom: 1px solid #ddd;
      font-weight: 500;
    }

    tbody td {
      padding: 4px 8px;
      height: 32px !important;
      border-bottom: 1px solid #eee;
      vertical-align: middle;
    }

    tbody tr:hover {
      background-color: #fafafa;
    }

    .user-action-buttons {
      display: flex;
      gap: 8px;
    }

    .admin-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
    }

    .group-stats {
      font-size: 13px;
      color: #666;
    }
  }

  /* .group-user {
    grid-template-columns: 1fr 1fr 1fr;

    p {
      margin: 0px;
    }

    .user-action-buttons {
      display: grid;
      grid-template-columns: repeat(auto-fill, 100px);
    }
  } */
`;

export { UserManagerWrap };
